import { Box, styled } from "@mui/material";
import {
    HeroSection,
    FeaturesSection,
    DashboardSection,
    BannerSection,
    GuaranteeSection,
    FAQSection
} from "../components";

import type { Feature } from "../components/FeaturesSection";

const PageContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

const ContentWrapper = styled(Box)(() => ({
    width: "100%",
    marginTop: "-50px",
    borderRadius: "50px 50px 0 0",
    backgroundColor: "var(--background-white)",
    position: "relative",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 600px)": {
        marginTop: "-32px",
        borderRadius: "32px 32px 0 0",
    },
}));

const ContentInner = styled(Box)(() => ({
    width: "100%",
    maxWidth: "1440px",
    padding: "106px 120px 60px 120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "56px",
    "@media (max-width: 600px)": {
        padding: "32px 16px 32px 16px",
        gap: "32px",
    },
}));

const features: Feature[] = [
    {
        title: "Снижаем риски",
        description:
            "Предварительный комплаенс и проверка контрагентов до отправки средств.",
    },
    {
        title: "Ускоряем платежи",
        description:
            "Автоматизация запросов на FX и переводы через прямые шлюзы.",
    },
    {
        title: "Legal-безопасность",
        description:
            "Полное онлайн-сопровождение сделок и верификация (KYC/KYB).",
    },
];



export const MainPage = () => {
    return (
        <PageContainer>
            <HeroSection
                backgroundImage="/assets/main-hero.webp"
                title="Свобода капитала без блокировок"
                subtitle="Единая платформа для международных финансов: от банкинга до консалтинга"
                buttonText="Попробовать бесплатно"
            />
            <ContentWrapper>
                <ContentInner>
                    <GuaranteeSection
                        title="Вы платите не за перевод"
                        description="Вы платите за гарантию того, что операция пройдет успешно. Мы берем на себя всю бюрократию и риски."
                    />
                    <FeaturesSection features={features} />
                    <DashboardSection
                        title="Ваш финансовый пульт управления"
                        description="Мы заменили сложную цепочку посредников на один понятный интерфейс."
                        imageSrc="/assets/main-dashboard-1.webp"
                    />

                    <DashboardSection
                        reverse
                        title="Умный личный кабинет"
                        description="Управление документами, транзакционными поручениями и историей операций в пару кликов."
                        imageSrc="/assets/main-dashboard-2.webp"
                    />

                    <DashboardSection
                        title="Валютные операции (FX) и переводы"
                        description="Автоматизированная подача запросов на конвертацию и вывод средств. Быстро и прозрачно."
                        imageSrc="/assets/main-dashboard-3.webp"
                    />

                    <DashboardSection
                        reverse
                        title="Верификация и Комплаенс"
                        description="Встроенная проверка через лицензированных KYC/KYB провайдеров. Ваши контрагенты всегда чисты перед законом."
                        imageSrc="/assets/main-dashboard-4.webp"
                    />

                    <BannerSection
                        title="Готовы вернуть контроль над своими активами?"
                        imageSrc="/assets/main-banner.webp"
                        imageAlt="GTC Platform"
                    />
                    <FAQSection />
                </ContentInner>
            </ContentWrapper>
        </PageContainer>
    );
};
